/**
 * <StudentTable
 * 		data={[student list in array]}
 *		settings={{setting object for the table}}
 *	/>
 *
 * @parent anybody
 * @children
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
//
import { Table, Button } from 'components/UI/Table';
import { browserHistory } from 'react-router';
import EnrollClass from 'template/Modals/EnrollClass';
import ExportModal from 'template/Modals/Export';
import CreateClassModal from 'template/Modals/CreateClass';
import __R, { userCan } from 'containers/__R'
import locale from '../locale'

const CONTROLLER_WIDTH = "14%";

class StudentTable extends React.Component {
  constructor(props) {
    super(props);

		this.convertToStudentTableData = this.convertToStudentTableData.bind(this);
		this.deleteMultipleStudents = this.deleteMultipleStudents.bind(this);
    this.enrollMultipleStudentsToClass = this.enrollMultipleStudentsToClass.bind(this);
	}

	static propTypes = {
		data: PropTypes.array.isRequired,
		settings: PropTypes.array,
	}

  componentWillReceiveProps(nextProp) {
  }

		// Ryan:
		// When props.data comes in to StudentTable, we convert it into
		// a format that StudentTable wants. This is a terrible way
		// because it is very complicated. It could be much simplified,
		// if we used <div> instead of nesting <tr>. However, we wanted
		// to write a flawless(?) table because we loved table.
	convertToStudentTableData(data) {
    let students = data.map((student, idx)=>{
			let row = [];

			// pushing classes into the row
			if (Array.isArray(student.list) && student.list.length > 0) {
				student.list.map((cls, idx)=>{
					if (idx == 0) {
						// we only need student data for the first row
						row[0] = { ...student, classInfo: cls };
						return;
					}
					// the next rows we omit student data
					row.push({
						classInfo: cls
					});
				});
			} else {
				// there is no class list!
				row[0] = { ...student }
			}

			return row;
		});

	  return students;
	}

  deleteMultipleStudents() {
    let { student } = this.props

    student.archiveMultipleSelectedStudents('deleting multiple studnets')
  }

  enrollMultipleStudentsToClass() {
    let { student } = this.props;

    let { studentSelectedByCheckbox, studentState } = student;

    EnrollClass({ students: studentSelectedByCheckbox })
    .then(({ updateRequired: updateStudentTableRequired })=>{
      if (updateStudentTableRequired) {
        student.fetchStudent('After editing classes @enroll-student-to-class', studentState);
        this.forceUpdate();
      }
    })
    .catch((err)=>{
      console.error(err);
    });
  }

	render() {
    let {
      data,
      settings,
      fields,
      fetching,
      trFilter,
      settingsModifier,
      onTrSelectionToggled,
      useMultiSelection,
      pagination,
      usePagination,
      onPageChange,
      onItemsCountPerPageChange,
      studentSelectedByCheckbox,
    } = this.props;

    const {deleting, studentState} = this.props.student
		return (
			<Table
				data={this.convertToStudentTableData(data)}
				fields={fields}
				className="student-table"
				settingThTitle={__('Settings', 'class')}
				settingWidth={CONTROLLER_WIDTH}
				settings={settings}
				useTbodyAsRow={true}
				oneSettingPerRow={true}
        onTrSelectionToggled={onTrSelectionToggled}
        fetching={fetching || deleting}

        dropdownGuideWidth={160}
        dropdownGuideHeight={228}

        trFilter={trFilter}
        settingsModifier={settingsModifier}
        usePagination={usePagination}
        pagination={pagination}
        onPageChange={onPageChange}
        onItemsCountPerPageChange={onItemsCountPerPageChange}
        useMultiSelection={true}

        hasTopUtilSection={studentState == 'archived' ? false : true}
        topUtilSection={
          <div>
            <__R can='assign_student_to_class' by='disable'>
              <button className='btn' disabled={studentSelectedByCheckbox.length < 1 ? 'disabled' : ''} onClick={this.enrollMultipleStudentsToClass}>
                {__('Join Class','studentTable')}
              </button>
            </__R>
            <__R can='create_class_and_assign_student' by='disable'>
              <button className='btn' disabled={studentSelectedByCheckbox.length < 1 ? 'disabled' : ''} onClick={() => {
                let studentIdList = []
                studentSelectedByCheckbox.map((student) => {
                  studentIdList.push(student.schoolStudentID)
                })
                CreateClassModal({mode: 'create', studentIdList})
              }}>
              {__('Create Class','studentTable')}
              </button>
            </__R>
            <__R can='archive_student_from_school' by='disable'>
              <button className='btn' disabled={studentSelectedByCheckbox.length < 1 ? 'disabled' : ''} onClick={this.deleteMultipleStudents}>
                {__('Archive Students', locale)}
              </button>
            </__R>
          </div>
        }
			/>
    );
  }
}

export default StudentTable;



// WEBPACK FOOTER //
// ./src/containers/pages/Student/StudentTable/index.js